"use client";

import * as React from "react";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";

import { useAuth } from "@/components/auth/custom/auth-context";

import { CustomSignOut } from "./custom-sign-out";

export function UserPopover({ anchorEl, onClose, open }) {
	const { user } = useAuth();

	return (
		<Popover
			anchorEl={anchorEl}
			anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
			onClose={onClose}
			open={Boolean(open)}
			slotProps={{ paper: { sx: { width: "260px" } } }}
			transformOrigin={{ horizontal: "right", vertical: "top" }}
		>
			<Box sx={{ p: 2 }}>
				<Typography>{user?.name}</Typography>
				<Typography color="text.secondary" variant="body2">
					{user?.email}
				</Typography>
			</Box>
			<Divider />
			<Box sx={{ p: 1 }}>
				<CustomSignOut />
			</Box>
		</Popover>
	);
}
